import { useLocation } from "react-router-dom";

import getPath from "@/modules/get-path";

const createPages = (project) => {
  const projectPath = getPath(project);
  const pages = {
    overview: { label: "Overview", href: projectPath },
    location: { label: "Location data", href: `${projectPath}/location` },
    aiAnalysis: {
      label: "AI Analysis",
      href: `${projectPath}/ai-analysis`,
    },
  };

  if (!project.isPromptEnabled) {
    delete pages.aiAnalysis;
  }

  if (!project.isLocationsEnabled) {
    delete pages.location;
  }

  return Object.values(pages);
};

export default function useProcessedPages(project, metadata) {
  const { pathname } = useLocation();
  const pages = createPages(project, metadata);
  const selectedPage = pages.findIndex((page) => pathname === page.href);
  return [pages, selectedPage];
}
